const 


// host="http://iraq-gis.com:3001/"
// host="https://www.iraq-gis.com/ticket/"
// host="http://localhost:3001/"
// host="http://192.168.0.103:8000/api/"
// host="http://192.168.80.4:3000/"
// host="http://192.168.80.175:8000/api/"
// host = "http://192.168.0.199:8000/api/"
// host="http://localhost:8000/api/"
host="https://demo-collections.iraq-gps.com/api/public/api/"
// host="https://collections.iraq-gps.com/api/public/api/"
// host="http://demo.jahizni.com/api/"
// host="http://demo.data-crew.com/api/public/api/"
// const FrontEndDomain="http://dev.ticket.is/";
// const FrontEndDomain="https://collections.iraq-gps.com/"
const FrontEndDomain="https://demo-collections.iraq-gps.com/";
//  const FrontEndDomain="http://192.168.80.176:3000/"
//  const FrontEndDomain="http://192.168.0.181:3000/"

// For backward compatibility, export host as default
export default host;
export { FrontEndDomain };

// Export Host object for new components that need additional configuration
export const Host = {
    API_URL: host,
    FRONTEND_DOMAIN: FrontEndDomain,
    // CAPATCHA_SECRET_KEY: "6Lci_bQpAAAAAG_EEXuT4t3_O5-SXX2tH5E9U440" // Test key, replace with your actual reCAPTCHA site key
    CAPATCHA_SECRET_KEY:"6LdL8IIrAAAAAPrMWJ1IW0nByHJjjo-zaK1nSnv0"//live
};
